import React from 'react';
import $ from 'jquery';

class CardTransportModal extends React.Component {

    closeModal = () => {
        const { idValidation } = this.props;
        $(`#${idValidation}`).modal('hide');
    };

    render() {
        const { idValidation, detailsData, duplicatedFilter, filter } = this.props;

        const {
            titleHead,
            register = [],
            Related,
            CodigoFiguraTransporte,
        } = detailsData || {};

        const type = duplicatedFilter?.find(dup => dup.value === filter?.duplicated);

        return (
            <div
                className="modal fade"
                id={idValidation}
                tabIndex="-1"
                role="dialog"
                aria-hidden="true"
                data-backdrop="static"
            >
                <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                    <div
                        className="modal-content"
                        style={{
                            borderRadius: "14px",
                            boxShadow: "rgb(1 1 1 / 25%) 1px 1px 12px"
                        }}
                    >
                        <div className="modal-body">
                            <h5
                                className="mb-3 text-center font-weight-bold"
                                style={{ fontSize: 18 }}
                            >
                                {type?.label ? `Detalles del ${type.label}` : ''}
                            </h5>
                            <div className="d-flex align-items-center justify-content-center mb-3">
                                <i
                                    className={type?.iconHead || "fa fa-truck"}
                                    style={{
                                        fontSize: 16,
                                        marginRight: 8
                                    }}
                                />

                                <div style={{
                                    fontWeight: 600,
                                    fontSize: 16
                                }}>
                                    {titleHead}
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-center mb-3">

                                {CodigoFiguraTransporte ? (
                                    <>
                                        <i
                                            className="fas fa-user-friends"
                                            style={{
                                                fontSize: 13,
                                                marginRight: 6
                                            }}
                                        />
                                        <div
                                            style={{
                                                fontWeight: 500,
                                                fontSize: 13
                                            }}
                                        >
                                            {Related}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <i
                                            className="fas fa-exclamation-circle"
                                            style={{
                                                fontSize: 13,
                                                marginRight: 6,
                                                color: "#ffc107"
                                            }}
                                        />
                                        <div
                                            style={{
                                                fontWeight: 500,
                                                fontSize: 13,
                                                color: "#856404"
                                            }}
                                        >
                                            {Related}
                                        </div>
                                    </>
                                )}

                            </div>

                            <div
                                className="mb-2"
                                style={{
                                    fontSize: 12,
                                    color: "#6c757d"
                                }}
                            >
                                {register.length} registro{register.length !== 1 ? 's' : ''}
                            </div>
                            <div
                                style={
                                    register.length > 5
                                        ? {
                                            maxHeight: 250,
                                            overflowY: "auto",
                                            paddingRight: 5,
                                            scrollbarWidth: "thin"
                                        }
                                        : {}
                                }
                            >
                                {register.map((item, index) => (
                                    <div
                                        key={index}
                                        className="d-flex align-items-center justify-content-center mb-3"
                                        style={{ fontSize: 14 }}
                                    >
                                        {/* Icono */}
                                        <div style={{ width: 22 }}>
                                            <i className={type?.iconBody || "fa fa-truck"} />
                                        </div>

                                        {/* Contenido */}
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontWeight: 600 }}>
                                                #{item.CodigoAutotransporte}
                                            </div>

                                            <div style={{ fontSize: 13, color: "#6c757d" }}>
                                                <span><strong>Placa:</strong> {item.PlacaVM}</span>
                                            </div>

                                            <div style={{ fontSize: 13, color: "#6c757d" }}>
                                                <span><strong>Ubicación:</strong> {item.U_FMB_BinLocation}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>

                        <div className="modal-footer justify-content-center border-0 pt-0">
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary"
                                onClick={this.closeModal}
                            >
                                Cerrar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default CardTransportModal;
